
import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { NumberOfApprovalDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-numberofapproval-container',
  templateUrl: './numberofapproval-container.component.html',
  styleUrls: ['./numberofapproval-container.component.scss']
})
export class NumberofapprovalContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  numberofapprovals$: Observable<NumberOfApprovalDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("NumberOfApproval");
    this.numberofapprovals$ = this.gatwayFacade.loadGateway("NumberOfApproval");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteNumberOfApproval(deletedValue: any) {
    this.gatwayFacade.remove("NumberOfApproval", deletedValue);
    // this.store.dispatch(NumberOfApprovalStoreActions.removeNumberOfApproval({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitNumberOfApproval(formValue: any) {
    console.log("form value: ", formValue);
    formValue.NumberOfApprovals = formValue.NumberOfApprovals.reverse();
    event.preventDefault();
    const pullData = formValue.NumberOfApprovals;
    //const newPullData = formValue.NumberOfApprovales;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllNumberOfApproval = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllNumberOfApproval.push(pullData[i]);
    }
  }

// check if the addAllNumberOfApproval array is not empty, then dispatch the data to the store
   if(addAllNumberOfApproval.length !== 0) {
    this.gatwayFacade.add('NumberOfApproval', addAllNumberOfApproval);
    // this.store.dispatch(NumberOfApprovalStoreActions.addNumberOfApproval({newNumberOfApproval: addAllNumberOfApproval}));

   }

// dispatch update data to the store
this.gatwayFacade.update('NumberOfApproval', allUpdates, ['id']);
    // this.store.dispatch(NumberOfApprovalStoreActions.updateNumberOfApproval({updateNumberOfApproval: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}



